export default "/images/bg-about.png?9cc4d76e0f07cafc0011edd4975f31bb";